'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import type { TERM_CATEGORY } from '@/api';
import { UnauthQueryOptions } from '@/api';
import { Selectbox } from '@/components/client';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
import { useGlobalStore } from '@/stores/GlobalStore';
export const TermsDrawer = () => {
  const $ = _c(31);
  const [termsDrawerType, setTermsDrawerType, termsDrawerMode, setTermsDrawerMode] = useGlobalStore(useShallow(_temp));
  let t0;
  if ($[0] !== termsDrawerType) {
    t0 = UnauthQueryOptions["get:/wello/v2/allows/log-term/{termCategory}"]({
      path: {
        termCategory: termsDrawerType as TERM_CATEGORY
      }
    });
    $[0] = termsDrawerType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!termsDrawerType;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data
  } = useQuery(t2);
  const [order, setOrder] = useState(0);
  const terms = data?.context?.contents;
  const selectedTerms = terms?.[order];
  let t3;
  if ($[5] !== selectedTerms?.contents) {
    t3 = selectedTerms?.contents?.replaceAll("\n", "");
    $[5] = selectedTerms?.contents;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const newLineFilterContents = t3;
  let t4;
  if ($[7] !== setTermsDrawerMode || $[8] !== setTermsDrawerType) {
    t4 = () => {
      setTermsDrawerType(null);
      setTermsDrawerMode("default");
      setOrder(0);
    };
    $[7] = setTermsDrawerMode;
    $[8] = setTermsDrawerType;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const closeDrawer = t4;
  useOverlayHistory(!!termsDrawerType, closeDrawer);
  const t5 = !!termsDrawerType;
  const t6 = termsDrawerMode === "bottom" ? "bottom" : "full";
  const t7 = termsDrawerMode === "bottom" ? "z-[60] bg-Gray-black/50" : undefined;
  const t8 = termsDrawerMode === "bottom" ? "z-[70]" : undefined;
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = {
      modal: "!min-h-[80vh] max-w-[800px]",
      backdrop: t7,
      drawer: t8
    };
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = selectedTerms?.title;
  let t11;
  if ($[13] !== t10) {
    t11 = <header className="sticky top-0 bg-Gray-white py-12"><h2 className="font-700 typo-body2">{t10}</h2></header>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = newLineFilterContents || "";
  let t13;
  if ($[15] !== t12) {
    t13 = <article className="overflow-auto text-[0.875rem] font-400 leading-[150%] text-Gray-900 [&>p]:my-[0.5em] [&_img]:h-auto [&_img]:w-full [&_li]:list-item [&_li]:pl-[0.5em] [&_ol]:list-decimal [&_ol]:pl-[2em] [&_ul]:pl-[2em]" dangerouslySetInnerHTML={{
      __html: t12
    }} />;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== terms) {
    t14 = terms?.map(_temp2);
    $[17] = terms;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e => setOrder(e.value);
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== order || $[21] !== t14) {
    t16 = <footer className="sticky bottom-0 w-full bg-Gray-white py-16"><Selectbox float="top" options={t14} value={order} onChange={t15} /></footer>;
    $[20] = order;
    $[21] = t14;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== closeDrawer || $[24] !== t11 || $[25] !== t13 || $[26] !== t16 || $[27] !== t5 || $[28] !== t6 || $[29] !== t9) {
    t17 = <ResponsiveDialog opened={t5} onClose={closeDrawer} drawerType={t6} className={t9}>{t11}{t13}{t16}</ResponsiveDialog>;
    $[23] = closeDrawer;
    $[24] = t11;
    $[25] = t13;
    $[26] = t16;
    $[27] = t5;
    $[28] = t6;
    $[29] = t9;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};
function _temp(state) {
  return [state.termsDrawerType, state.setTermsDrawerType, state.termsDrawerMode, state.setTermsDrawerMode] as const;
}
function _temp2(t0, index) {
  const {
    title,
    createAt
  } = t0;
  return {
    label: `${title} ${dayjs(createAt).format("YYYY.MM.DD")}`,
    value: index
  };
}